import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import { useStaticQuery, graphql } from "gatsby";

import { Row } from "react-bootstrap";
import SectionHeader from "components/SectionHeader";
import IndustryItem from "components/IndustryItem";
import PageSection from "components/PageSection";
import "./Industries.scss";

const Industry = ({ className }) => {
  const { markdownRemark = {} } = useStaticQuery(graphql`
    query IndustryQuery {
      markdownRemark(fields: { fileName: { regex: "/industries/i" } }) {
        frontmatter {
          anchor
          header
          subheader
          industries {
            content
            extraInfo
            header
            imageFileName
            imageFileNameDetail
            subheader
          }
        }
      }
    }
  `);

  const frontmatter = markdownRemark.frontmatter;
  if (!frontmatter) {
    return null;
  }

  const { anchor, header: rootHeader, subheader: rootSubHeader, industries } = frontmatter;

  return (
    <PageSection className={clsx("industry-section", className)} id={anchor}>
      <Row>
        <SectionHeader header={rootHeader} subheader={rootSubHeader} />
      </Row>
      <Row>
        {industries.map(
          ({ content, extraInfo, header, imageFileName, imageFileNameDetail, subheader }) => (
            <IndustryItem
              key={header}
              imageFileName={imageFileName}
              header={header}
              subheader={subheader}
              content={content}
              imageFileNameDetail={imageFileNameDetail}
              extraInfo={
                <ul>
                  {extraInfo.map((ei) => (
                    <li key={ei}>{ei}</li>
                  ))}
                </ul>
              }
            />
          ),
        )}
      </Row>
    </PageSection>
  );
};

Industry.propTypes = {
  className: PropTypes.string,
};

Industry.defaultProps = {
  className: null,
};

export default Industry;
